import React, {useContext, useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import './CSS/Logout.css'


/*
### KEEP THIS ###
SmartLuggage Application
Marek Augustyn
2023
This is working logout component with the button that will be visible when user was successfully logged in

*/

export const Logout = ({loginStatus1}) => {
    const navigate = useNavigate();
    const [jwtToken, setJwtToken] = useState(localStorage.getItem("userTokenLoginForm"));
    const [loginStatus, setLoginStatus] = useState(localStorage.getItem("userLoginStatus"));


    //function used for logout, it cleans the JWT token
    function logout(event){
        // event.preventDefault();//For test only
        let token1 = localStorage.getItem("userTokenLoginForm");
        if(token1 !== " "){
            localStorage.setItem('userTokenLoginForm', " ");
            localStorage.setItem('userLoginStatus', "Not verified");
            localStorage.setItem('isLoggedIn', "false" )
            navigate("/Login");
            // alert("Logout successful.");
        }
        else{
            alert("User is already logged out");
        }
    }


    // Variable and function refresh
    const [pageWasRefreshed, setPageWasRefreshed] = useState(false);

    function refresh(){

        if(pageWasRefreshed === true){
            window.location.reload();
        }
        else if(pageWasRefreshed === true){
            console.log("Page was refreshed already")
        }

    }

    // Set a variable setPageWasRefreshed as a true and do refresh function.
    useEffect(() => {
        setPageWasRefreshed(true);
        const intervalCall = setInterval(()=>{
                refresh();
            }
            ,2000);
        return () => {
            clearInterval(intervalCall);
        }
    }, []); // 👈️ empty dependencies array




    return (
        <div>
            {/*logout button appear only if user is verified*/}
            <form id="formInLogout" onSubmit={logout}>
                {loginStatus==="verified" ? <button  id="buttonInLogout"
            className="waves-effect waves-light btn #795548 brown "
            type="submit" name="action">
                Logout user
            </button> : <div id="notLoggedUser"> "No one is logged in, please log in first. Thank you." </div>}
            </form>


        </div>


    );
}
export default Logout;
